// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Set from "@rescript/runtime/lib/es6/Belt_Set.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as Belt_MapInt from "@rescript/runtime/lib/es6/Belt_MapInt.js";
import * as MouseButton from "./MouseButton.res.js";
import * as MouseButtons from "./MouseButtons.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

function use(getPosition, buttonOpt, onStart, onMove, onEnd, onPinch, stopPropagationOpt) {
  let button = buttonOpt !== undefined ? buttonOpt : "Main";
  let stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : true;
  let match = React.useState(() => {});
  let setPointerMove = match[1];
  let pointerMove = match[0];
  let pointersRef = React.useRef(undefined);
  let setPointers = f => {
    pointersRef.current = f(pointersRef.current);
  };
  let pointers = pointersRef.current;
  let updatePointerForEvent = (pos, e) => Belt_MapInt.set(pos, e.pointerId, e);
  return {
    pointerMove: pointerMove,
    onPointerDown: e => {
      setPointers(p => updatePointerForEvent(p, e));
      if (!(e.isPrimary && (Primitive_object.equal(MouseButton.fromPointerEvent(e), button) || e.pointerType === "touch"))) {
        return;
      }
      let position = getPosition(e);
      setPointerMove(param => ({
        from: position,
        to: position
      }));
      Stdlib_Option.forEach(onStart, onStart => onStart(e, position));
      if (stopPropagation) {
        e.stopPropagation();
        return;
      }
    },
    onPointerMove: e => {
      setPointers(p => updatePointerForEvent(p, e));
      let pointerIdInt = e.pointerId;
      let position = getPosition(e);
      if (Belt_MapInt.size(pointers) === 2 && Belt_MapInt.has(pointers, pointerIdInt)) {
        let otherPointer = Belt_MapInt.valuesToArray(Belt_MapInt.remove(pointers, pointerIdInt))[0];
        let otherPosition = getPosition(otherPointer);
        let prevPointer = Belt_MapInt.getExn(pointers, pointerIdInt);
        let prevPosition = getPosition(prevPointer);
        let prevDiff = V2f$Linear.diff(otherPosition, prevPosition);
        let diff = V2f$Linear.diff(otherPosition, position);
        let percentageDiff = diff === 0 ? 1 : 1 - prevDiff / diff;
        Stdlib_Option.forEach(onPinch, onPinch => onPinch([
          prevPointer,
          otherPointer
        ], [
          e,
          otherPointer
        ], percentageDiff));
      }
      Stdlib_Option.forEach(pointerMove, param => {
        if (!e.isPrimary) {
          return;
        }
        let to = getPosition(e);
        let position_from = param.from;
        let position = {
          from: position_from,
          to: to
        };
        setPointerMove(param => position);
        Stdlib_Option.forEach(onMove, onMove => onMove(e, position));
        if (stopPropagation) {
          e.stopPropagation();
          return;
        }
      });
    },
    onPointerUp: e => {
      setPointers(p => Belt_MapInt.remove(p, e.pointerId));
      if (e.isPrimary && (Primitive_object.equal(MouseButton.fromPointerEvent(e), button) || e.pointerType === "touch")) {
        Stdlib_Option.forEach(pointerMove, move => {
          setPointerMove(param => {});
          Stdlib_Option.forEach(onEnd, onEnd => onEnd(e, move));
        });
        if (stopPropagation) {
          e.stopPropagation();
          return;
        } else {
          return;
        }
      }
    },
    onPointerLeave: e => {
      setPointers(p => Belt_MapInt.remove(p, e.pointerId));
      if (e.isPrimary) {
        return Stdlib_Option.forEach(pointerMove, move => {
          Stdlib_Option.forEach(onEnd, onEnd => onEnd(e, move));
          setPointerMove(param => {});
          if (stopPropagation) {
            e.stopPropagation();
            return;
          }
        });
      }
    },
    onPointerOut: e => setPointers(p => Belt_MapInt.remove(p, e.pointerId)),
    onPointerCancel: e => setPointers(p => Belt_MapInt.remove(p, e.pointerId)),
    onPointerEnter: e => {
      if (e.isPrimary) {
        return Stdlib_Option.forEach(pointerMove, move => {
          if (!Stdlib_Option.mapOr(MouseButtons.fromPointerEvent(e), false, buttons => Belt_Set.has(buttons, button))) {
            setPointerMove(param => {});
            Stdlib_Option.forEach(onEnd, onEnd => onEnd(e, move));
            if (stopPropagation) {
              e.stopPropagation();
              return;
            } else {
              return;
            }
          }
        });
      }
    }
  };
}

export {
  use,
}
/* react Not a pure module */
